/**
 * Проверки порядка/корректности дат (§15 НФТ: «даты не должны быть в некорректном порядке»).
 * Отдельный util-файл, чтобы не конфликтовать с параллельными правками validation.ts (IC-3).
 *
 * Формат входа — ISO `YYYY-MM-DD` (значение `<input type="date">`); пустая строка трактуется
 * как «не указано» и НЕ считается ошибкой (обязательность — забота required-проверок формы).
 * Все сравнения — на уровне календарного дня (время игнорируется).
 */

/** Парсит `YYYY-MM-DD` в локальную полночь; null — если пусто/некорректно. */
function parseISODate(value: string): Date | null {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value.trim())
  if (!m) return null
  const d = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]))
  // Отсекаем «переполнение» (напр. 2024-02-31 → март): компоненты должны совпасть.
  if (d.getFullYear() !== Number(m[1]) || d.getMonth() !== Number(m[2]) - 1 || d.getDate() !== Number(m[3])) {
    return null
  }
  return d
}

function startOfDay(d: Date): Date {
  return new Date(d.getFullYear(), d.getMonth(), d.getDate())
}

/**
 * Дата не в будущем (≤ сегодня). Пустая/некорректная строка — валидна (не наша забота).
 * Пример: дата рождения, дата обучения/оценки не могут быть позже сегодняшнего дня.
 */
export function isNotFutureDate(value: string, now: Date = new Date()): boolean {
  const d = parseISODate(value)
  if (!d) return true
  return startOfDay(d).getTime() <= startOfDay(now).getTime()
}

/**
 * Порядок пары дат: `to` не раньше `from` («до ≥ от»). Если любая из дат пуста/некорректна —
 * считаем валидным (пара ещё не задана целиком). Равенство допускается.
 */
export function isDateOrderValid(from: string, to: string): boolean {
  const a = parseISODate(from)
  const b = parseISODate(to)
  if (!a || !b) return true
  return startOfDay(b).getTime() >= startOfDay(a).getTime()
}
